import React from 'react';
import '../css/myLogs.css'

const Entity = ({ entities_array }) => {
    return (
        <div className="entity-table-container">
            <table className="entity-table">
                <thead>
                    <tr>
                        <th>Class [Gear Score]</th>
                        <th>Name</th>
                        <th>DPS</th>
                        <th>Brand%</th>
                        <th>Buff%</th>
                        <th>Iden%</th>
                    </tr>
                </thead>
                <tbody>
                    {entities_array.map((entity, index) => (
                        <tr key={index}>
                            <td>{entity.class} {entity.gear_score ? [Math.round(entity.gear_score)] : ''}</td>
                            <td>{entity.name}</td>
                            <td>{entity.dps ? `${Math.round(entity.dps/10000)/100} M`: ''}</td>
                            <td>{entity.buffedBySupport ? `${Math.round((entity.buffedBySupport/entity.damageDealt)*100)}%`: ''}</td>
                            <td>{entity.buffedBySupport ? `${Math.round((entity.debuffedBySupport/entity.damageDealt)*100)}%`: ''}</td>
                            <td>{entity.buffedBySupport ? `${Math.round((entity.buffedByIdentity/entity.damageDealt)*100)}%`: ''}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Entity;
